import { useAtom } from "jotai";
import { atomWithStorage, useAtomValue } from "jotai/utils";

import * as flowConfig from "flows/clustering/config";

const PREFIX = `${flowConfig.FLOW_NAME}/create`;

const overlayToBeShown = atomWithStorage(`${PREFIX}/show-create-overlay`, true);

export const useOverlayStatus = () => useAtom(overlayToBeShown);

export const useGetOverlayDisplay = () => useAtomValue(overlayToBeShown);

const inputFile = atomWithStorage<string>(`${PREFIX}/input-file`, null);

export const useInputFile = () => useAtom(inputFile);

export const useGetInputFile = () => useAtomValue(inputFile);
